module.exports = __webpack_public_path__ + "img/Cloud-Icon.svg";